import { render } from "./AboutExpertise.vue?vue&type=template&id=ee0e7ee8"
import script from "./AboutExpertise.vue?vue&type=script&lang=js"
export * from "./AboutExpertise.vue?vue&type=script&lang=js"

import "./AboutExpertise.sass?vue&type=style&index=0&lang=sass&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__